import { z } from 'zod';
export const menuItemDtoSchema = z.object({
    id: z.string(),
    sectionId: z.string(),
    name: z.string(),
    subtitle: z.string().nullable(),
    description: z.string().nullable(),
    note: z.string().nullable(),
    price: z.string(),
    photoUrl: z.string().nullable(),
    order: z.number().int(),
});
export const menuSectionDtoSchema = z.object({
    id: z.string(),
    categoryId: z.string(),
    title: z.string(),
    note: z.string().nullable(),
    paragraphs: z.array(z.string()),
    plainItems: z.array(z.string()),
    order: z.number().int(),
    items: z.array(menuItemDtoSchema),
});
export const menuCategoryDtoSchema = z.object({
    id: z.string(),
    title: z.string(),
    order: z.number().int(),
    sections: z.array(menuSectionDtoSchema),
});
/* ---------- mutation requests ---------- */
export const createMenuCategorySchema = z.object({
    title: z.string().trim().min(1).max(120),
    order: z.number().int().optional(),
});
export const updateMenuCategorySchema = createMenuCategorySchema.partial();
export const createMenuSectionSchema = z.object({
    categoryId: z.string(),
    title: z.string().trim().min(1).max(160),
    note: z.string().trim().max(240).optional().nullable(),
    paragraphs: z.array(z.string().trim().max(2000)).optional(),
    plainItems: z.array(z.string().trim().max(240)).optional(),
    order: z.number().int().optional(),
});
export const updateMenuSectionSchema = createMenuSectionSchema.partial();
export const createMenuItemSchema = z.object({
    sectionId: z.string(),
    name: z.string().trim().min(1).max(200),
    subtitle: z.string().trim().max(200).optional().nullable(),
    description: z.string().trim().max(600).optional().nullable(),
    note: z.string().trim().max(200).optional().nullable(),
    price: z.string().trim().min(0).max(80),
    photoUrl: z.string().url().max(2048).optional().nullable(),
    order: z.number().int().optional(),
});
export const updateMenuItemSchema = createMenuItemSchema.partial();
